export function saveToLocalStorage(STORAGE_KEY, data) {
  return Promise.resolve(window.localStorage[STORAGE_KEY] = JSON.stringify(data));
}

export function getFromLocalStorage(STORAGE_KEY) {
  return window.localStorage[STORAGE_KEY] && JSON.parse(window.localStorage[STORAGE_KEY]);
}

export function initLocalStorage(STORAGE_KEY) {
  if (!window.localStorage[STORAGE_KEY]) {
    window.localStorage[STORAGE_KEY] = '{}';
  }
  return window.localStorage.getItem(STORAGE_KEY);
}

// These two seem to be only used by the client for testing.
export function saveState(STORAGE_KEY, data) {
  return Promise.resolve(window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data)));
}

export function loadState(STORAGE_KEY) {
  const state = window.localStorage.getItem(STORAGE_KEY);
  return Promise.resolve(state ? JSON.parse(state) : {}); // not necessary now but able to resolve as promise
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/persistenceUtils.js